const SUPPORT_EMAIL = 'support@meridianeventtech.com';

const EmailLink = () => <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>;

function Privacy() {
  return (
    <section id="privacy" className="privacy">
      <div className="container container--narrow">
        <h1 className="section-title">Privacy Policy</h1>
        <p className="privacy-dates">
          Effective Date: September 30, 2026
          <br />
          Last Updated: September 30, 2026
        </p>

        <div className="privacy-body">
          <p>
            Meridian Event Tech (&ldquo;Meridian,&rdquo; &ldquo;we,&rdquo;
            &ldquo;us,&rdquo; or &ldquo;our&rdquo;) provides event technology
            and data services to businesses (&ldquo;Clients&rdquo;). This
            Privacy Policy explains how we handle personal information when we
            operate registration forms, scheduling tools, email communications,
            and related services on behalf of our Clients (collectively, the
            &ldquo;Services&rdquo;).
          </p>

          <h2>1. Our Role</h2>
          <p>
            We collect and process personal information only on behalf of our
            Clients and according to their instructions. For this information,
            the Client is the controller (or &ldquo;business&rdquo;) and is
            responsible for determining how the information is used. Meridian
            acts as a processor (or &ldquo;service provider&rdquo;). The
            Client&rsquo;s privacy policy governs how your information is used,
            and we encourage you to review it. Each Client&rsquo;s privacy
            policy is typically linked from the registration form or event page
            where you submitted your information.
          </p>

          <h2>2. Information We Process on Behalf of Clients</h2>
          <p>Depending on the Client program, this may include:</p>
          <ul>
            <li>
              Contact details such as name, email address, phone number, and
              mailing address
            </li>
            <li>
              Registration information, such as event registrations, appointment
              bookings, survey responses, and preferences
            </li>
            <li>
              Device and technical data, such as IP address, browser type, and
              operating system, which may be used to determine approximate
              location (such as city or region)
            </li>
            <li>
              Information the Client provides to us so that we can deliver the
              program, such as invite or attendee lists
            </li>
            <li>
              Payment information, processed by our third-party payment
              processor. We do not store any payment information
            </li>
          </ul>
          <p>We do not collect precise geolocation or payment information.</p>

          <h2>3. How We Use Information</h2>
          <p>
            We use personal information only to provide the Services to our
            Clients, including to:
          </p>
          <ul>
            <li>Operate registration forms, scheduling, and event programs</li>
            <li>
              Send transactional messages on the Client&rsquo;s behalf, such as
              confirmations, reminders, and program updates
            </li>
            <li>
              Provide reporting to the Client about program participation and
              performance
            </li>
            <li>Maintain the security and functionality of our systems</li>
            <li>Comply with legal obligations</li>
          </ul>
          <p>
            We do not use personal information for our own marketing, and we do
            not send marketing communications.
          </p>

          <h2>4. How We Share Information</h2>
          <p>
            We do not sell personal information, and we do not share it for
            targeted or cross-context behavioral advertising. We disclose
            personal information only:
          </p>
          <ul>
            <li>To the Client on whose behalf it was collected</li>
            <li>
              To subprocessors that help us deliver the Services, such as
              hosting, email delivery, scheduling, and data storage providers,
              under contracts that require them to protect the information and
              use it only to provide services to us
            </li>
            <li>
              When required by law or to protect the rights, property, or safety
              of Meridian, our Clients, or others
            </li>
            <li>
              To a successor in connection with a merger, acquisition, or sale of
              assets, subject to our existing obligations to Clients
            </li>
          </ul>

          <h2>5. Your Privacy Rights</h2>
          <p>
            Depending on where you live, you may have rights under state privacy
            laws, such as the Colorado Privacy Act or the California Consumer
            Privacy Act, including the right to access, correct, or delete your
            personal information. Because we process your information on behalf
            of our Clients, please submit privacy requests directly to the
            Client whose program you participated in.
          </p>
          <p>
            If you contact us with a request, we will forward it to the
            appropriate Client and assist the Client in responding as required
            by law and our agreements. You can reach us at <EmailLink />.
          </p>

          <h2>6. Cookies and Tracking</h2>
          <p>
            We do not use cookies, pixels, or similar tracking technologies.
          </p>

          <h2>7. Data Retention</h2>
          <p>
            We retain personal information only as long as needed to provide the
            Services to the Client. We de-identify personal information within
            18 months of collection, or sooner if the Client requires a shorter
            period, by removing all information that identifies or could
            reasonably be linked to an individual. We maintain and use
            de-identified information only in de-identified form and will not
            attempt to re-identify it. When our work for a Client ends, we
            delete, return, or de-identify the Client&rsquo;s personal
            information as the Client instructs, unless the law requires us to
            keep it.
          </p>

          <h2>8. Data Security</h2>
          <p>
            We use reasonable administrative, technical, and physical safeguards
            to protect personal information. No method of transmission or
            storage is completely secure, and we cannot guarantee absolute
            security.
          </p>

          <h2>9. Children&rsquo;s Privacy</h2>
          <p>
            The Services are not directed to individuals under 18, and we do not
            knowingly collect personal information from anyone under 18. If you
            believe someone under 18 has provided personal information through
            our Services, contact us and we will work with the Client to delete
            it.
          </p>

          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Policy from time to time. We will post the
            updated version with a new &ldquo;Last Updated&rdquo; date.
          </p>

          <h2>11. Contact Us</h2>
          <address>
            Meridian Event Tech
            <br />
            660 Briggs St
            <br />
            Erie, CO 80516
            <br />
            Email: <EmailLink />
          </address>
        </div>
      </div>
    </section>
  );
}

export default Privacy;
